import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import StoryViewer from "@/PublicViewer";
import PublicHome from "@/PublicHome";
import ImpactPage from "@/ImpactPage";
import MapPage from "@/MapPage";
import BooksPage from "@/BooksPage";
import BookPage from "@/BookPage";
import HelpPage from "@/HelpPage";
import AboutPage from "@/AboutPage";
import TilloPage from "@/TilloPage";
import TilloAboutPage from "@/TilloAboutPage";
import TilloEpisodePage from "@/TilloEpisodePage";
import ShortLinkRedirect from "@/ShortLinkRedirect";
import { captureEntrySource } from "@/entrySource";

captureEntrySource();

// Route split (no router dependency — the app has a small set of public surfaces):
//   /studio         -> the creator app (upload + render + library)
//   /impact         -> filterable charity / rescue / impact gallery
//   /map            -> explore stories by place (interactive world map)
//   /books          -> index of multi-chapter series ("books")
//   /book/{key}     -> one book: chapters + audiobook feed
//   /s/{slug}       -> a single published story (video + language dropdown + CC)
//   /  (anything else) -> gallery of all published stories
function Router() {
  const path = window.location.pathname;
  if (path.startsWith("/studio")) return <App />;
  if (path.startsWith("/help")) return <HelpPage />;
  let page;
  if (path.startsWith("/impact")) page = <ImpactPage />;
  else if (path.startsWith("/about")) page = <AboutPage />;
  else if (path.startsWith("/kids/about")) page = <TilloAboutPage />;
  else if (path.startsWith("/kids/episode/")) {
    const id = decodeURIComponent(path.slice("/kids/episode/".length).split("/")[0] || "");
    page = <TilloEpisodePage episodeId={id} />;
  } else if (path.startsWith("/kids")) page = <TilloPage />;
  else if (path.startsWith("/map")) page = <MapPage />;
  else if (path.startsWith("/books") || path.startsWith("/series")) page = <BooksPage />;
  else if (path.startsWith("/book/")) {
    const key = decodeURIComponent(path.slice(6).split("/")[0] || "");
    page = <BookPage seriesKey={key} />;
  } else if (path.startsWith("/s/")) {
    const slug = decodeURIComponent(path.slice(3).split("/")[0] || "");
    page = <StoryViewer slug={slug} />;
  } else {
    // Single unknown segment ⇒ short promotional link (storylo.co.uk/farage).
    // Resolves via the API and redirects straight to the story — unknown
    // slugs fall back to the home gallery.
    const seg = path.replace(/^\/+|\/+$/g, "");
    if (seg && !seg.includes("/")) {
      page = <ShortLinkRedirect slug={decodeURIComponent(seg)} />;
    } else {
      page = <PublicHome />;
    }
  }
  return page;
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Router />
  </React.StrictMode>,
);
